import {serverFlagMaxRunsLimit} from '../../../../config';

/**
 * Get the max runs that are defaulted in the panels
 * If a user can use the custom default, return that value
 */
export const DEFAULT_LINE_PLOT_NUM_RUNS_OLD = 10; // legacy setting
/**
 * This was bumped to 30 because want to start increasing the default number
 * of runs in a workspace panel. However, this slows down the RSDQ given that
 * backend parallelism is limited and not likely to be delivered imminently. So
 * we ware bumping this value back to 10 until we can process things more
 * efficiently on the backend.
 *
 * https://weightsandbiases.slack.com/archives/C010Y174QGH/p1714422864169979
 */
export const DEFAULT_LINE_PLOT_NUM_RUNS_NEW = 10;

// allow the ability to override the max runs limit w/ a server flag
export const DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS = serverFlagMaxRunsLimit(); // defaults to 50, default for FF
export const DEFAULT_LINE_PLOT_NUM_RUNS_SAMPLING = 100; // sampling is allowed to have a higher limit
export const DEFAULT_LINE_PLOT_MAX_GROUP_RUNS = 100; // we allow more runs in FF for groups
export const DEFAULT_FEATURE_FLAG_FULL_FIDELITY_MAX_RUNS = 100; // experimental ramp flag based limit
export const DEFAULT_PANEL_MAX_NUM_RUNS = 300; // panels that aren't line plots need higher limits for [reasons]
